import templateUrl from 'emun.map/map-customer.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

class MapCustomerController  {
    constructor($scope, $geo, $http, leafletData) {
        const $ctrl = this;
		basicController($ctrl);
		$ctrl.token = 'pk.eyJ1IjoiYnJhbmRvbmx1c2siLCJhIjoiY2pmMWk2M2ZtMGUwcjJxbG5udTF1MGlzYyJ9.GFvALV_-d7a6aNuppmAhaw';
		$ctrl.center = {
			lat: 37.0902,
			lng: -95.7129,
			zoom: 4
		}
		//$ctrl.tiles = {
		//	name: 'Mapbox Park',
		//	url: 'http://api.tiles.mapbox.com/v4/{mapid}/{z}/{x}/{y}.png?access_token={apikey}',
		//	type: 'xyz',
		//	options: {
		//		apikey: $ctrl.token,
		//		mapid: 'mapbox.streets'
		//	}
		//}
		$ctrl.geojson = {};
		$ctrl.$geo = $geo;
		$ctrl.$http = $http;
		$ctrl.leafletData = leafletData;
		$ctrl.selectedMarker = {};
		$ctrl.fills = {
			'HIGH': '#3182bd',
			'MEDIUM': '#9ecae1',
			'LOW': '#deebf7',
			'defaultFill': '#DDDDDD'
		}

		$ctrl.$on("leafletDirectiveMarker.mymap.click", function (ev, leafletPayload) {
			//console.info("BL*** got marker click " + JSON.stringify(leafletPayload.leafletObject.options));
			$ctrl.selectedMarker = leafletPayload.leafletObject.options._data;
			leafletPayload.leafletObject.bindPopup();
		});

		$ctrl.$on("leafletDirectiveMap.mymap.moveend", function (ev, leafletPayload) {
			$ctrl.search();
		});

		$ctrl.layers = {
			baselayers: {
				openStreetMap: {
					name: 'Street View',
					type: 'xyz',
					url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
				}
			},
			overlays: {
				Customers: {
					type: 'group',
					name: 'Customers',
					visible: true
				},

				Prospects: {
					type: 'group',
					name: 'Prospects',
					visible: false
				}
			}
		};

		$http.get("https://s3.amazonaws.com/emuncloud-staticassets/mapfiles/us-states.json").success(function (data, status) {
			data.features.forEach(function (feature) {
				var state = $ctrl.$geo.usaStates.find(function (obj) { return obj.name === feature.properties.name; });
				if (state) {
					feature.properties = angular.extend(feature.properties, {
						"abbr": state.abbreviation
					});
				}
			});
			$ctrl.salesQuery = new AutoQuery({
				url: 'QuerySalesYOYTotals.json?Sum=TotalSalesMonthToDate,TotalSalesQuarterToDate,TotalSalesYearToDate,TotalSalesMonthToDateLastYear,TotalSalesQuarterToDateLastYear,TotalSalesYearToDateLastYear&GroupBy=SalesRepState',
				autoLoad: true,
				onLoaded: function (args) {
					args.results.forEach(function (res) {
						var feature = data.features.find(function (obj) {
							return obj.properties.abbr === res.salesRepState;
						});
						if (feature) {
							var color = $ctrl.fills.defaultFill;
							if (res.sumTotalSalesYearToDate <= 50000) {
								color = $ctrl.fills.LOW;
							} else if (res.sumTotalSalesYearToDate <= 100000) {
								color = $ctrl.fills.MEDIUM;
							} else {
								color = $ctrl.fills.HIGH;
							}
							feature.properties = angular.extend(feature.properties, {
								"fillColor": color,
								"sales": res.sumTotalSalesYearToDate
							});
						}
					});
					$ctrl.style = function (feature) {
						return {
							fillColor: feature.properties.fillColor,
							weight: 2,
							opacity: 1,
							color: 'white',
							dashArray: '3',
							fillOpacity: 0.7
						};
					}
					angular.extend($ctrl.layers.overlays, {
						states: {
							name: 'Sales by State',
							type: 'geoJSONShape',
							data: data,
							visible: false,
							layerOptions: {
								style: $ctrl.style
							}
						}
					});
					$ctrl.legend = {
						colors: [$ctrl.fills.defaultFill, $ctrl.fills.LOW, $ctrl.fills.MEDIUM, $ctrl.fills.HIGH],
						labels: ['No Sales', '$1 - $50,000', '$50,001 - $100,000', '> $100,000']
					}
				}
			});
		});



		let options = {
			url: 'QueryRetailLocations.json',
			onLoading(args) {
				let q = $ctrl.query.criteria;
				let zip = q.ZipCode;
				let distance = q.Radius;
				if (!zip || zip.length !== 5) return false;
//				$ctrl.center = zip + ' USA';
				return true; //$scope.map.center = zip;
			},
			onLoaded: function (args) {
				$ctrl.markers = [];
				args.results.forEach(function (obj) {
					$geo.findAddresses(obj.address + ' ' + obj.zip).then(results => {
						console.info('mapify.results', results);
						if (results.length) {
							$geo.apply(results[0], obj);
							$ctrl.markers.push({
								layer: "Customers",
								lat: obj.geometry.location.lat,
								lng: obj.geometry.location.lng,
								_data: obj,
								message: "<h4>" + obj.companyName + "</h4>" + obj.address + "</br>" + obj.city + ", " + obj.state + " " + obj.zip + "</br><strong>Phone: </strong>" + obj.phone
							});
							console.info('$geo.apply', JSON.stringify(obj));
						}
					});
				});
			},
			criteria: {
				ZipCode: '14850',
				Radius: 25
			},
			autoLoad: false,
			append: false
		};
		$ctrl.query = new AutoQuery(options);
		$ctrl.findMe();
		//$http.get('https://ipinfo.io/json').then(
		//	res => {
		//		if (res && res.data && res.data.postal) {
		//			$ctrl.query.criteria.ZipCode = res.data.postal;
		//			$ctrl.loc = res.data.loc.split(',');
		//			$ctrl.center.lat = parseFloat($ctrl.loc[0]);
		//			$ctrl.center.lng = parseFloat($ctrl.loc[1]);
		//			$ctrl.center.zoom = 14;
		//			$ctrl.query.load(true);
		//		} else {
		//			this.getGeoZip();
		//		}
		//	},
		//	res => this.getGeoZip())
	}
	goToZip() {
		let $ctrl = this;
		$ctrl.$geo.findAddresses($ctrl.query.criteria.ZipCode).then(function (addresses) {
			if (addresses.length) {
				$ctrl.center.lat = parseFloat(addresses[0].geometry.location.lat);
				$ctrl.center.lng = parseFloat(addresses[0].geometry.location.lng);
				$ctrl.search();
//				$ctrl.query.load(true);
			}
		});
	}
	search() {
		let $ctrl = this;
		$ctrl.$geo.findAddresses($ctrl.center.lat + "," + $ctrl.center.lng).then(function (addresses) {
			if (addresses.length) {
				addresses[0].address_components.forEach(function (comp) {
					if (comp.types[0] == "postal_code") {
						$ctrl.query.criteria.ZipCode = comp.short_name;
						$ctrl.query.load(true);
					}
				});
			}
		});
	}
	findMe() {
		let $ctrl = this;
		$ctrl.$http.get('https://ipinfo.io/json').then(
			res => {
				if (res && res.data && res.data.postal) {
					$ctrl.query.criteria.ZipCode = res.data.postal;
					$ctrl.loc = res.data.loc.split(',');
					$ctrl.center.lat = parseFloat($ctrl.loc[0]);
					$ctrl.center.lng = parseFloat($ctrl.loc[1]);
					$ctrl.center.zoom = 14;
					$ctrl.query.load(true);
				} else {
					this.getGeoZip();
				}
			},
			res => this.getGeoZip())
	}
}

let MapCustomerView = {
	bindings: {
		customerId: '@'
	},
    controller: MapCustomerController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default MapCustomerView;